import { FC } from 'react';

import Checkbox from '@/components/ui/Checkbox';
import { FormField } from '@/components/ui/Form';
import cn from '@/utils/cn';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const PRIVACY_POLICY_NAME = 'privacy_policy';

interface Props {
  name?: string;
}

const CheckboxPrivacyPolicy: FC<Props> = ({ name = PRIVACY_POLICY_NAME }) => {
  const { i18n } = useLingui();
  const { control, trigger } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        validate: (value) =>
          value === true || i18n.t('Zaznacz zgodę aby przejść dalej'),
      }}
      render={({
        field: { value, onChange, ref, ...field },
        fieldState: { error },
      }) => (
        <Checkbox
          ref={ref}
          checked={value}
          onCheckedChange={(checked) => {
            onChange(checked === true);
            if (error) trigger(name);
          }}
          label={i18n.t(
            'Akceptuję politykę prywatności oraz regulamin świadczenia usług przez Helpfind.'
          )}
          error={error?.message}
          classNameBox={cn('bg-gray-100', !error && 'outline-dark-gray-100')}
          {...field}
        />
      )}
    />
  );
};

export default CheckboxPrivacyPolicy;
